import ApplicationDetail from '@/components/ApplicationDetail/ApplicationDetail.vue';

export default {
    components: {
        ApplicationDetail,
    },
};
